// extracted by mini-css-extract-plugin
export default {"container":"TextAreaWithAutocomplete_container__H7W+t","dropdown":"TextAreaWithAutocomplete_dropdown__tHTD5"};